import { render } from "./SPManagementHeader.vue?vue&type=template&id=38f2d87d&scoped=true"
import script from "./SPManagementHeader.vue?vue&type=script&lang=js"
export * from "./SPManagementHeader.vue?vue&type=script&lang=js"

import "./SPManagementHeader.vue?vue&type=style&index=0&id=38f2d87d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f2d87d"]])

export default __exports__